import { render, staticRenderFns } from "./InvoiceServices.vue?vue&type=template&id=0917ddae"
import script from "./InvoiceServices.vue?vue&type=script&lang=js"
export * from "./InvoiceServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports